export default {
    name: 'CircleSmallFill',
    dimensions: { width: 14, height: 15 },
    content: `
    <path fill="currentColor" stroke="currentColor" d="M7 13.5C10.3137 13.5 13 10.8137 13 7.5C13 4.18629 10.3137 1.5 7 1.5C3.68629 1.5 1 4.18629 1 7.5C1 10.8137 3.68629 13.5 7 13.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  `
};

